var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextPreparationStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.640625C18.3513 0.640625 23.5 5.78935 23.5 12.1406C23.5 18.4919 18.3513 23.6406 12 23.6406C5.64873 23.6406 0.5 18.4919 0.5 12.1406C0.5 5.78935 5.64873 0.640625 12 0.640625Z",
    stroke: "#E2E8F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12.1422,
    r: 2.4,
    fill: "#F1F5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPreparationStatus);
export default __webpack_public_path__ + "static/media/next-preparation-status.a3b5f11a.svg";
export { ForwardRef as ReactComponent };